import { createSlice } from '@reduxjs/toolkit';

const productSlice = createSlice({
  name: "product",
  initialState: {
    products: [],
    lastFetch: null, // Timestamp de la última carga exitosa
  },
  reducers: {
    setProducts(state, action) {
      state.products = action.payload;
      state.lastFetch = Date.now(); // Actualiza el timestamp
    }
  }
});

export const { setProducts } = productSlice.actions;
export default productSlice.reducer;
